<template>
    <div id="crrecords">
        <div id="headers">
            <i class="arr" @click="goBack()"></i>
            <p class="title">{{title}}</p>
            <form :action="formUrl" method="post" ref="tbForm">
                <button type="button" class="subBtn"  @click="reportTable">导出记录</button>
            </form>
        </div>
        <div class="listBox">
            <p class="wranTop">请严格保护用户隐私，禁止任何形式的非法复制、传播和使用用户信息</p>
            <div class="setFix"></div>
            <div class="item-list" v-for="item in tLists">
                <div class="top nowrap">
                    <span class="leftMsg nowrap">{{item.name}}-{{item.mobile}}({{item.pass=="1"?'进门':'出门'}})</span>
                    <span class="ownerRight">{{item.owner?item.owner:''}}</span>
                </div>
                <div class="btm">
                    {{item.created_at}}
                </div>
            </div>
        </div>
        <div class="noLists" v-show="noShow && tLists.length == 0">
            <img src="~@/assets/imgs/bg.png" alt />
            <p>暂无数据~</p>
        </div>
        <!-- 弹层遮罩 -->
        <div class="bigMask" v-show="showMask" @click="closeMask">
            <p class="one">1、点击右上角“...”</p>
            <p>2、选择“在浏览器打开”后即可导出记录</p>
            <img src="@/assets/imgs/arrow.png" alt="">
        </div>
    </div>
</template>
<script>
import Top from "@/component/top/top";
import { Toast } from 'mint-ui';
import axios from 'axios'
export default {
    components:{
        Top
    },
    data() {
        return {
            title:'出入记录',
            noShow:false,
            tLists:[],
            formUrl:null,
            showMask:false
        }
    },
    mounted() {
        // this.setuserToken('wr7w4pRzr4pK8a5ZC090rM8K7Jm95Acz')
        // this.crLists()
        axios.post(this.commonIp()+'/v1/mobile/community/userInfo')
        .then((res) => {
            if(res.data.code=='200') {
                this.setuserToken(res.data.data.token)
                this.crLists()
                this.formUrl = `${this.commonIp()}/v1/userCard/userLog?export=1&token=${this.getuserToken()}&poiId=${this.$route.query.poiId}`
            }else if(res.data.code == '424'||res.data.code == '423'){
                if (this.isAndroid() || this.isIos()) {
                    window.location.href = "app://login";
                } else {
                    window.location.href = `${this.commonIp()}/quickLogin?referer=${encodeURIComponent(window.location.href)}`;
                }
            }
        })
    },
    methods:{
        reportTable() {
            let ua = navigator.userAgent.toLowerCase();
            if(ua.match(/MicroMessenger/i)=="micromessenger") {
                this.showMask = true
            } else {
                this.$refs.tbForm.submit()
                this.showMask = false
            }
        },
        closeMask() {
            this.showMask = false
        },
        crLists() {
            axios.post(this.commonIp()+'/v1/userCard/userLog',{
                token:this.getuserToken(),
                poiId:this.$route.query.poiId
            }).then((res) => {
                if(res.data.code == '200') {
                    if(res.data.data.logs.length==0) {
                        this.noShow = true
                    }else{
                        this.tLists = res.data.data.logs
                    }
                }
            })
        },
        goBack() {
            this.$router.go(-1)
        },
    }
}
</script>
<style lang="less">
    @import "~@/assets/less/index.less";
    #crrecords{
        .subBtn{
            border:0;
            background:0;
            outline: none;
        }
        .setFix{
            height: 80px;
            border-bottom:1px solid #d8d8d8;
        }
        .listBox{
            .item-list{
                padding:10px 15px;
                border-bottom:1px solid #d8d8d8;
                .top{
                    display: flex;
                    .leftMsg{
                        flex:0 0 220px;
                        width:220px; 
                    }
                    .ownerRight{
                        flex:1;
                        text-align: right;
                    }
                }
                .btm{
                    margin-top:5px;
                    font-size:@ft12;
                    color:@gray;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/crrecords/crrecords.vue